export enum PackingSupplierStatusEnum{
    OPEN = 'Open',
    ASN = 'ASN',
    PARTIAL_ASN = 'PARTIAL ASN'
}